import { combineReducers } from '@reduxjs/toolkit';

// vehicleData
import { airbag } from './airbag';
import { bodyType } from './bodyType';
import { camera } from './camera';
import { climate } from './climate';
import { colorInterior } from './colorInterior';
import { colorVehicle } from './colorVehicle';
import { colorVehicleType } from './colorVehicleType';
import { cruise } from './cruise';
import { driveunit } from './driveunit';
import { fuel } from './fuel';
import { owners } from './owners';
import { powerSteering } from './powerSteering';
import { registration } from './registration';
import { seatsHeat } from './seatsHeat';
import { seatsType } from './seatsType';
import { transmission } from './transmission';
import { vehicleExchange } from './vehicleExchange';

export default combineReducers({
    airbag,
    bodyType,
    camera,
    climate,
    colorInterior,
    colorVehicle,
    colorVehicleType,
    cruise,
    owners,
    powerSteering,
    registration,
    seatsHeat,
    seatsType,
    transmission,
    vehicleExchange,
    driveunit,
    fuel,
});
